function syntaxHighlight(json: any) {
    if (typeof json !== "string") {
        json = JSON.stringify(json, null, 2);
    }
    json = json
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");

    return json.replace(
        /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
        (match) => {
            let cls = "text-gray-800";
            if (/^"/.test(match)) {
                if (/:$/.test(match)) {
                    cls = "text-blue-600"; // Key
                } else {
                    cls = "text-green-700"; // String value
                }
            } else if (/true|false/.test(match)) {
                cls = "text-purple-600"; // Boolean
            } else if (/null/.test(match)) {
                cls = "text-red-600 italic"; // Null
            } else if (/^-?\d+/.test(match)) {
                cls = "text-yellow-700"; // Number
            }
            return `<span class="${cls}">${match}</span>`;
        }
    );
}

export default syntaxHighlight;